module.exports = __webpack_public_path__ + "img/ill2.dfafe8fa.png";